import {
    ACCEPT_SUBMISSION,
    ACCEPT_TIME,
    ACCEPT_TYPE,
    CHECK_CUSTOMER_TYPE,
    CANCEL_TYPE,
    CANCEL_SUBMISSION,
    CANCEL_TIME,
    CHANGES_TIME,
    CHANGE_DATE,
    CHANGE_CUSTOMER_TYPE,
    CUSTOMER_TYPE,
    CHANGE_NAME,
    CHANGE_NOTES,
    CHANGE_PAX,
    CHANGE_PHONE,
    CLOSE_TNC,
    ERROR_DATE,
    ERROR_PAX,
    ERROR_TYPE,
    ERROR_TIME,
    INITIAL_BRANDS,
    INITIAL_RESERVATION,
    INITIAL_RESERVATION_HISTORY,
    PAYMENT_DECISION,
    RESET,
    RESET_ERROR,
    SUBMIT_ONPROGRESS,
    SUBMIT_REQUEST
} from "./types";

const initiate = {
    // Dashboard
    currentTab: 0,
    listHistoryReservation: [],
    initialFetch: true,
    brands: [],

    // Form
    outlet: {},
    bookingType:"",
    bookingStatus:"",
    bookingName: "",
    bookingPhone: "",
    bookingDate: "",
    bookingTime: "",
    bookingPax: "",
    bookingNotes: "",
    errorDate: "",
    errorTime: "",
    errorPax: "",
    errorNotes: "",
    tncPolicy: null,
    limitReservation: "",
    listBookingTime: null,
    listCustomerType:null,
    bookingSetting: null,
    showTimePicker: false,
    showTypePicker: false,
    showTncPolicy: false,
    disagreeTncPolicy: false,
    showConfirmation: false,
    progressModal: false,
    completeReservation: false,
    paymentUrl: "",
    expiredTime: "",
    paymentOption: false,
}

const ReservationReducer = (state = initiate, action) => {
    switch (action.type) {
        // History
        case INITIAL_RESERVATION_HISTORY:
            return {
                ...state,
                ...action.payload,
            };
        case INITIAL_BRANDS:
            return {
                ...state,
                ...action.payload,
            };
            // Form
        case INITIAL_RESERVATION:
            return {
                ...state,
                ...action.payload,
            };
        case CHANGE_NAME:
            return {
                ...state,
                ...action.payload,
            };
        case CHANGE_PHONE:
            return {
                ...state,
                ...action.payload,
            };
        case CUSTOMER_TYPE:
            return {
                ...state,
                ...action.payload,
            };
        case CHANGE_DATE:
            return {
                ...state,
                ...action.payload,
            };
        case CHANGE_CUSTOMER_TYPE:
            return {
                ...state,
                ...action.payload,
            };
            
        case CHANGES_TIME:
            return {
                ...state,
                ...action.payload,
            };
        case ACCEPT_TIME:
            return {
                ...state,
                ...action.payload,
            };
        case ACCEPT_TYPE:
            return {
                ...state,
                ...action.payload,
            };
        case CHECK_CUSTOMER_TYPE:
            return {
                ...state,
                ...action.payload,
            };
        case CLOSE_TNC:
            return {
                ...state,
                ...action.payload,
            };
        case CHANGE_PAX:
            return {
                ...state,
                ...action.payload,
            };
        case CHANGE_NOTES:
            return {
                ...state,
                ...action.payload,
            };
        case ERROR_DATE:
            return {
                ...state,
                errorDate: action.payload,
            };
        case ERROR_PAX:
            return {
                ...state,
                errorPax: action.payload,
            };
         case ERROR_TYPE:
            return {
                ...state,
                errorType: action.payload,
            };    
        case ERROR_TIME:
            return {
                ...state,
                errorTime: action.payload,
            };
        case CANCEL_TIME:
            return {
                ...state,
                ...action.payload,
            };
        case CANCEL_TYPE:
            return {
                ...state,
                ...action.payload,
            };    
        case SUBMIT_REQUEST:
            return {
                ...state,
                ...action.payload,
            };
        case RESET_ERROR:
            return {
                ...state,
                ...action.payload,
            };
        case SUBMIT_ONPROGRESS:
            return {
                ...state,
                ...action.payload,
            };
        case CANCEL_SUBMISSION:
            return {
                ...state,
                ...action.payload,
            };
        case ACCEPT_SUBMISSION:
            return {
                ...state,
                ...action.payload,
            };
        case PAYMENT_DECISION:
            return {
                ...state,
                ...action.payload,
            };
        case RESET:
            let reset = initiate;

            return {
                ...reset
            };
        default:
            return state;
    }
}

export default ReservationReducer;